import { useEffect, useState, useRef } from "react";
import GoogleMapReact from "google-map-react";
import "./Map.scss";
import { LandmarkIconsHighlight } from "../common/LandmarkIcons";
// import CollarBlack from "../../assets/images/collar/collar-black.png";
import CollarIcon from "../../assets/images/collar/collar.png";
import HerdMarkerIcon from "../../assets/images/Union.svg";
import HerdMarkerIconYellow from "../../assets/images/HerdMarkerIconYellow.svg";
import CowBlack from "../../assets/images/collar/cow-black.png";
import { checkLineIntersection } from "../../services/map-service";

function Map(props) {
  // eslint-disable-next-line no-unused-vars
  const [center, setCenter] = useState({
    lat: 47.118107603812064,
    lng: -112.19421616045743,
  });
  const [map, setMap] = useState(null);
  const [maps, setMaps] = useState(null);
  // const [drawingManager, setDrawingManager] = useState(null);
  const drawingManager = useRef();
  const [markers, setMarkers] = useState([]);
  const [polyline, setPolyline] = useState(null);
  const [paddockFencePolygon, setPaddockFencePolygon] = useState(null);
  const [fencePolygon, setFencePolygon] = useState(null);
  const {
    landmark,
    currentTutorial,
    currentStepDetails,
    setHerdMarkerDetails,
    setCurrentStep,
    setVenceInclusionDetails,
    setVenceExclusionDetails,
  } = props;

  // Herd setting up tutorial
  const [gatewayMarker, setGatewayMarker] = useState(null);
  const [rectangle, setRectangle] = useState(null);
  const [createHerdRectangle, setCreateHerdRectangle] = useState(null);
  const [herdMarker, setHerdMarker] = useState(null);
  const [animalsWithCollar, setAnimalsWithCollar] = useState([]);
  const [animalsWithIcon, setAnimalsWithIcon] = useState([]);

  // Creating vences tutorial
  const [venceStep4HighlightedArea, setVenceStep4HighlightedArea] =
    useState(null);
  const currentStepDetailsRef = useRef(currentStepDetails); // This ref is used for getting latest currentStepDetails inside event handlers
  const [venceInclusionPolygon, setVenceInclusionPolygon] = useState(null);
  const [venceInclusionRedZonePolygon, setVenceInclusionRedZonePolygon] =
    useState(null);
  const [venceStep12HighlightedArea, setVenceStep12HighlightedArea] =
    useState(null);
  const [venceExclusionPolygon, setVenceExclusionPolygon] = useState(null);
  const [venceExclusionRedZonePolygon, setVenceExclusionRedZonePolygon] =
    useState(null);

  // Assigning vences tutorial
  const [herdMarkerForVence, setHerdMarkerForVence] = useState(null);
  const [paddockSectionMarkers, setPaddockSectionMarkers] = useState([]);

  const handleApiLoaded = (map, maps) => {
    setMap(map);
    setMaps(maps);
  };

  const handleMapClick = (mapProps) => {
    const latLng = new maps.LatLng(mapProps.lat, mapProps.lng);
    if (currentTutorial === "LANDMARKS_SETTING_UP") {
      if (currentStepDetails.landmark === "Gateway") {
        // Point
        addGatewayMarker(latLng);
      } else if (landmark.shape === 2) {
        // Line
        if (!polyline) drawLine(latLng);
        else addLatLngToLine(latLng);
      } else if (landmark.shape === 3) {
        // Polygon
        // if(!fencePolygon) drawPolygon(latLng);
        // else addLatLngToPolygon(latLng);
      }
    }
  };

  const addMarker = (latLng) => {
    const marker = new maps.Marker({
      position: latLng,
      map: map,
      icon: {
        url: LandmarkIconsHighlight[landmark.type],
        scaledSize: new maps.Size(28, 28),
      },
      draggable: true,
    });
    setMarkers([...markers, marker]);
  };

  const updateMarker = (latLng) => {
    const [marker] = markers;
    marker.setPosition(latLng);
    setMarkers([marker]);
  };

  const addGatewayMarker = (latLng) => {
    if (!gatewayMarker) {
      const marker = new maps.Marker({
        position: latLng,
        map: map,
        icon: {
          url: LandmarkIconsHighlight[currentStepDetails.landmark],
          scaledSize: new maps.Size(28, 28),
        },
        draggable: true,
      });
      setGatewayMarker(marker);
    } else {
      if (!gatewayMarker.map) gatewayMarker.setMap(map);
      gatewayMarker.setPosition(latLng);
    }
  };

  const drawLine = (latLngs) => {
    const poly = new maps.Polyline({
      path: [latLngs],
      map: map,
      cursor: "crosshair",
      draggableCursor: "crosshair",
      strokeColor: "#00ff00",
      strokeOpacity: 1,
      strokeWeight: 3,
      clickable: true,
      editable: true,
      geodesic: true,
      optimized: false,
    });
    setPolyline(poly);
  };

  const addLatLngToLine = (latLng) => {
    polyline.getPath().push(latLng);
  };

  const drawPolygon = (latLngs) => {
    const poly = new maps.Polygon({
      paths: [latLngs],
      map: map,
      cursor: "crosshair",
      draggableCursor: "crosshair",
      strokeColor: "#00ff00",
      strokeOpacity: 0.8,
      strokeWeight: 3,
      clickable: true,
      editable: true,
      geodesic: true,
      fillColor: "#ffffff",
      fillOpacity: 0.35,
      optimized: false,
    });
    setFencePolygon(poly);
  };

  const addLatLngToPolygon = (latLng) => {
    fencePolygon.getPath().push(latLng);
  };

  useEffect(() => {
    const fenceCoords = [
      {
        lat: 47.12396257008059,
        lng: -112.1965335890463,
      },
      {
        lat: 47.123991770292534,
        lng: -112.18722095934659,
      },
      {
        lat: 47.12165570268796,
        lng: -112.18580475298673,
      },
      {
        lat: 47.11593190352904,
        lng: -112.18872299639493,
      },
      {
        lat: 47.114179597016275,
        lng: -112.1919416472128,
      },
      {
        lat: 47.1124856458716,
        lng: -112.18996754137784,
      },
      {
        lat: 47.113062427985966,
        lng: -112.19600755676338,
      },
      {
        lat: 47.11463578254446,
        lng: -112.19774020067722,
      },
      {
        lat: 47.11550817218741,
        lng: -112.19998792018846,
      },
      {
        lat: 47.119465546145705,
        lng: -112.19769230334073,
      },
      {
        lat: 47.12080885284903,
        lng: -112.19683399645596,
      },
    ];
    if (!map || !maps) return;
    const poly = new maps.Polygon({
      paths: fenceCoords,
      map: map,
      cursor: "crosshair",
      draggableCursor: "crosshair",
      strokeColor: "#ffffff",
      strokeOpacity: 0.8,
      strokeWeight: 3,
      clickable: true,
      editable: false,
      geodesic: true,
      fillColor: "#ffffff",
      fillOpacity: 0.2,
      optimized: false,
    });
    setPaddockFencePolygon(poly);
  }, [currentTutorial, map, maps]);

  const animalsCoords = [
    {
      lat: 47.12242745741982,
      lng: -112.19234628754518,
    },
    {
      lat: 47.12178503016439,
      lng: -112.1922604568567,
    },
    {
      lat: 47.12260266350678,
      lng: -112.19071550446412,
    },
    {
      lat: 47.121580619865334,
      lng: -112.19058675843141,
    },
    {
      lat: 47.122369055262624,
      lng: -112.18856973725221,
    },
    {
      lat: 47.12131780546971,
      lng: -112.18848390656373,
    },
    {
      lat: 47.11965328414854,
      lng: -112.19127340393922,
    },
    {
      lat: 47.120383343770825,
      lng: -112.19015760498903,
    },
    {
      lat: 47.120003714017436,
      lng: -112.18908472138307,
    },
    {
      lat: 47.119507271021995,
      lng: -112.18972845154664,
    },
  ];

  const addAnimalsWithCollar = () => {
    if (!map || !maps) return;
    let markers = [];
    for (let i = 0; i < animalsCoords.length; i++) {
      const marker = new maps.Marker({
        position: animalsCoords[i],
        // map: map,
        icon: {
          url: CollarIcon,
          scaledSize: new maps.Size(24, 20),
        },
      });
      markers.push(marker);
    }
    setAnimalsWithCollar(markers);
  };

  const addAnimalsWithIcon = (coords) => {
    if (!map || !maps) return;
    let markers = [];
    for (let i = 0; i < coords.length; i++) {
      const marker = new maps.Marker({
        position: coords[i],
        // map: map,
        icon: {
          url: CowBlack,
          scaledSize: new maps.Size(28, 28),
        },
      });
      markers.push(marker);
    }
    setAnimalsWithIcon(markers);
  };

  const addHerdMarker = () => {
    const marker = new maps.Marker({
      position: {
        lat: 47.12133339265566,
        lng: -112.19018316162803,
      },
      // map: map,
      label: {
        text: "10",
        fontFamily: "Material Icons",
        color: "#ffffff",
        fontSize: "14px",
        className: "p-15",
      },
      icon: {
        url: HerdMarkerIcon,
        scaledSize: new maps.Size(28, 28),
      },
    });
    setHerdMarker(marker);
  };

  const drawRectangle = () => {
    const rect = new maps.Rectangle({
      strokeColor: "#0f0",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#f00",
      fillOpacity: 0.0,
      // map: map,
      draggable: true,
      editable: true,
      bounds: {
        south: 47.11882308312466,
        west: -112.19520321337491,
        north: 47.12478016995669,
        east: -112.18340149370938,
      },
    });
    setRectangle(rect);
  };

  const drawVenceHighlightedArea = (latLngs, step) => {
    const poly = new maps.Polygon({
      paths: latLngs,
      // map: map,
      cursor: "crosshair",
      draggableCursor: "crosshair",
      strokeColor: "#F1DC1E",
      strokeOpacity: 0.5,
      strokeWeight: 0.1,
      geodesic: true,
      fillColor: "#F1DC1E",
      fillOpacity: 0.4,
      optimized: false,
    });
    if (step === "Step4") setVenceStep4HighlightedArea(poly);
    else if (step === "Step12") setVenceStep12HighlightedArea(poly);
  };

  const drawVencePolygon = (latLngs) => {
    const poly = new maps.Polygon({
      paths: latLngs,
      map: map,
      strokeColor: "#ffffff",
      strokeOpacity: 0.8,
      strokeWeight: 1,
      fillColor: "#ffffff",
      fillOpacity: 0.1,
      optimized: false,
    });
  };

  const drawVenceRedZone = (distance, bounds, radius) => {
    let heading = maps.geometry.spherical.computeHeading(bounds[0], bounds[1]);
    let headings = bounds.map((b, index, arr) => {
      let nextPoint =
        index === arr.length - 1 ? arr[arr.length - 1] : arr[index + 1];
      return maps.geometry.spherical.computeHeading(b, nextPoint);
    });
    let avgHeading = headings.reduce((a, b) => a + b) / headings.length;
    let newCoords = bounds.map((each, index, arr) => {
      let nextPoint =
        index === arr.length - 1 ? arr[arr.length - 1] : arr[index + 1];
      // let newHeading = maps.geometry.spherical.computeHeading(each, nextPoint);
      // let newHeading = headings[index];
      let newHeading = avgHeading;
      if (bounds.length === 2) newHeading = heading;
      return maps.geometry.spherical.computeOffset(
        each,
        distance,
        newHeading + radius
      );
    });
    const poly = new maps.Polygon({
      paths: [...newCoords, ...bounds.reverse()],
      strokeColor: "#D62D23",
      strokeOpacity: 0.1,
      strokeWeight: 0.1,
      fillColor: "#D62D23",
      fillOpacity: 0.35,
      geodesic: true,
      map: map,
    });
  };

  const addHerdMarkerForVence = () => {
    const marker = new maps.Marker({
      position: {
        lat: 47.12110087155752,
        lng: -112.19112625567227,
      },
      map: map,
      label: {
        text: "10",
        fontFamily: "Material Icons",
        color: "#ffffff",
        fontSize: "14px",
        className: "p-15",
      },
      icon: {
        url: HerdMarkerIcon,
        scaledSize: new maps.Size(28, 28),
      },
    });
    setHerdMarkerForVence(marker);
  };

  const addPaddockSectionMarkers = () => {
    if (!map || !maps) return;
    let markers = [];
    for (let i = 0; i < paddockSectionCoords.length; i++) {
      const marker = new maps.Marker({
        position: paddockSectionCoords[i],
        // map: map,
        label: {
          text: (i + 1).toString(),
          fontFamily: "Material Icons",
          color: "#000000",
          fontSize: "14px",
          className: "p-15",
        },
        icon: {
          scaledSize: new maps.Size(24, 20),
          path: maps.SymbolPath.CIRCLE,
          fillColor: "#ffffff",
          fillOpacity: 1.0,
          scale: 10,
          strokeColor: "#000000",
          strokeWeight: 1.0,
        },
      });
      markers.push(marker);
    }
    setPaddockSectionMarkers(markers);
  };

  const venceStep4HighlightedOuterCoords = [
    {
      lat: 47.11937291901098,
      lng: -112.20091754923195,
    },
    {
      lat: 47.11811718641066,
      lng: -112.1840518189463,
    },
    {
      lat: 47.12661470541936,
      lng: -112.1825926972422,
    },
    {
      lat: 47.126673102915646,
      lng: -112.20066005716652,
    },
  ];

  const venceStep4HighlightedInnerCoords = [
    {
      lat: 47.12107432336485,
      lng: -112.197923239204,
    },
    {
      lat: 47.120431879769846,
      lng: -112.18663650366933,
    },
    {
      lat: 47.12498722137317,
      lng: -112.18590694281728,
    },
    {
      lat: 47.12501642102268,
      lng: -112.197923239204,
    },
  ];

  const venceStep12HighlightedOuterCoords = [
    {
      lat: 47.124371371589376,
      lng: -112.19043961016446,
    },
    {
      lat: 47.125422561043976,
      lng: -112.18357315508634,
    },
    {
      lat: 47.11791778115513,
      lng: -112.18228569475919,
    },
    {
      lat: 47.110966885210935,
      lng: -112.18687763659268,
    },
    {
      lat: 47.11175547788665,
      lng: -112.19258537737637,
    },
    {
      lat: 47.11453006293498,
      lng: -112.19425907580167,
    },
    {
      lat: 47.11677883099235,
      lng: -112.19035377947598,
    },
    {
      lat: 47.121743307074375,
      lng: -112.18807926623136,
    },
  ];

  const venceStep12HighlightedInnerCoords = [
    {
      lat: 47.12413777111189,
      lng: -112.1895813032797,
    },
    {
      lat: 47.124984567962294,
      lng: -112.18413105456143,
    },
    {
      lat: 47.11791778115513,
      lng: -112.18301525561124,
    },
    {
      lat: 47.11143420079966,
      lng: -112.18722095934659,
    },
    {
      lat: 47.11216437319239,
      lng: -112.1922849699667,
    },
    {
      lat: 47.11447165210884,
      lng: -112.1936153456381,
    },
    {
      lat: 47.116632809977624,
      lng: -112.18979588000089,
    },
    {
      lat: 47.12183091131652,
      lng: -112.18747845141202,
    },
  ];

  const inclusionSection1Coords = [
    {
      lat: 47.120195608344034,
      lng: -112.19807854143887,
    },
    {
      lat: 47.1188814891744,
      lng: -112.18627682177335,
    },
    {
      lat: 47.12539336161741,
      lng: -112.18477478472501,
    },
    {
      lat: 47.1249553682953,
      lng: -112.19782104937345,
    },
  ];

  const inclusionSection2Coords = [
    {
      lat: 47.11485132133288,
      lng: -112.20082512347012,
    },
    {
      lat: 47.11704166780911,
      lng: -112.18683472124845,
    },
    {
      lat: 47.121684904166145,
      lng: -112.18447437731534,
    },
    {
      lat: 47.12060443879942,
      lng: -112.20275631396085,
    },
  ];

  const exclusionRedZoneCoords = [
    {
      lat: 47.11175547788665,
      lng: -112.19258537737637,
    },
    {
      lat: 47.11453006293498,
      lng: -112.19425907580167,
    },
    {
      lat: 47.11677883099235,
      lng: -112.19035377947598,
    },
    {
      lat: 47.121743307074375,
      lng: -112.18807926623136,
    },
    {
      lat: 47.124371371589376,
      lng: -112.19043961016446,
    },
  ];

  const paddockSectionCoords = [
    {
      lat: 47.122385734833664,
      lng: -112.19271412340909,
    },
    {
      lat: 47.11806379864364,
      lng: -112.19520321337491,
    },
    {
      lat: 47.114588473697054,
      lng: -112.19571819750577,
    },
  ];

  useEffect(() => {
    if (!map || !maps) return;
    addDrawingManager();
    if (currentTutorial === "HERDS_SETTING_UP") {
      addHerdMarker();
      addAnimalsWithCollar();
    }
    if (currentTutorial === "VENCES_CREATING") {
      drawVenceHighlightedArea(
        [
          venceStep4HighlightedOuterCoords,
          venceStep4HighlightedInnerCoords.reverse(),
        ],
        "Step4"
      );
      drawVenceHighlightedArea(
        [
          venceStep12HighlightedOuterCoords,
          venceStep12HighlightedInnerCoords.reverse(),
        ],
        "Step12"
      );
    }
    if (currentTutorial === "VENCES_ASSIGNING") {
      drawVencePolygon(inclusionSection1Coords);
      drawVencePolygon(inclusionSection2Coords);
      drawVencePolygon(venceStep12HighlightedOuterCoords);
      drawVenceRedZone(
        50,
        [inclusionSection1Coords[0], inclusionSection1Coords[1]],
        -90
      );
      drawVenceRedZone(
        50,
        [inclusionSection2Coords[0], inclusionSection2Coords[1]],
        -90
      );
      drawVenceRedZone(200, exclusionRedZoneCoords, 90);
      addHerdMarkerForVence();
      addPaddockSectionMarkers();
    }
  }, [map, maps]);

  const addDrawingManager = () => {
    drawingManager.current = new maps.drawing.DrawingManager({
      drawingControl: false,
      drawingControlOptions: {
        position: maps.ControlPosition.TOP_CENTER,
      },
      map: map,
      polygonOptions: {
        cursor: "crosshair",
        draggableCursor: "crosshair",
        strokeColor: "#00ff00",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        clickable: true,
        editable: true,
        fillColor: "#ffffff",
        fillOpacity: 0.35,
      },
      rectangleOptions: {
        strokeColor: "#0f0",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#f00",
        fillOpacity: 0.0,
        editable: true,
      },
      polylineOptions: {
        strokeColor: "#0f0",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        editable: true,
      },
      markerOptions: {
        draggable: true,
      },
      circleOptions: {
        fillColor: "#ffffff",
        fillOpacity: 0.1,
        strokeColor: "#00ff00",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        clickable: false,
        editable: true,
        zIndex: 1,
      },
    });
    maps.event.addListener(
      drawingManager.current,
      "overlaycomplete",
      function (event) {
        const { type, overlay } = event;
        drawingManager.current.setDrawingMode(null);
        if (type === "polygon") {
          if (currentTutorial === "VENCES_CREATING") {
            if (currentStepDetailsRef.current?.step === 4) {
              overlay.setOptions({
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillOpacity: 0.1,
              });
              setVenceInclusionPolygon(overlay);
              setCurrentStep((step) => step + 1);
            }
            if (currentStepDetailsRef.current?.step === 11) {
              overlay.setOptions({
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillOpacity: 0.1,
              });
              setVenceExclusionPolygon(overlay);
              setCurrentStep((step) => step + 1);
            }
          } else {
            setFencePolygon(overlay);
          }
        } else if (type === "rectangle") {
          if (currentTutorial === "HERDS_SETTING_UP") {
            setCreateHerdRectangle(overlay);
          }
        } else if (type === "polyline") {
        } else if (type === "circle") {
        } else if (type === "marker") {
        }
      }
    );
  };

  const hookStateRefs = {
    fencePolygon: fencePolygon,
    gatewayMarker: gatewayMarker,

    herdMarker: herdMarker,
    animalsWithCollar: animalsWithCollar,
    animalsWithIcon: animalsWithIcon,
    rectangle: rectangle,
    createHerdRectangle: createHerdRectangle,

    venceStep4HighlightedArea: venceStep4HighlightedArea,
    venceInclusionPolygon: venceInclusionPolygon,
    venceInclusionRedZonePolygon: venceInclusionRedZonePolygon,
    venceStep12HighlightedArea: venceStep12HighlightedArea,
    venceExclusionPolygon: venceExclusionPolygon,
    venceExclusionRedZonePolygon: venceExclusionRedZonePolygon,

    paddockSectionMarkers: paddockSectionMarkers,
  };

  const functionsWithRefs = {
    fencePolygon: setFencePolygon,
    gatewayMarker: setGatewayMarker,

    herdMarker: setHerdMarker,
    animalsWithCollar: setAnimalsWithCollar,
    animalsWithIcon: setAnimalsWithIcon,
    rectangle: setRectangle,
    createHerdRectangle: setCreateHerdRectangle,

    venceStep4HighlightedArea: setVenceStep4HighlightedArea,
    venceInclusionPolygon: setVenceInclusionPolygon,
    venceInclusionRedZonePolygon: setVenceInclusionRedZonePolygon,
    venceStep12HighlightedArea: setVenceStep12HighlightedArea,
    venceExclusionPolygon: setVenceExclusionPolygon,
    venceExclusionRedZonePolygon: setVenceExclusionRedZonePolygon,

    paddockSectionMarkers: setPaddockSectionMarkers,
  };

  useEffect(() => {
    if (!map || !maps || !drawingManager) return;
    if (currentStepDetails.step) {
      currentStepDetails?.mapMarkers?.forEach((marker) => {
        if (hookStateRefs[marker]) {
          if (Array.isArray(hookStateRefs[marker])) {
            hookStateRefs[marker].forEach((m) => m.setMap(map));
          } else {
            hookStateRefs[marker].setMap(map);
            if (hookStateRefs[marker].editable) {
              // If marker is editable from previous step then make it as not editable.
              hookStateRefs[marker].setEditable(false);
              hookStateRefs[marker].setOptions({
                strokeColor: "#ffffff",
              });
            }
          }
        }
      });

      // If markers are drawn by user and if user going back to previous step then remove them.
      currentStepDetails.clearMarkers?.forEach((marker) => {
        if (hookStateRefs[marker]) {
          hookStateRefs[marker].setMap(null);
          functionsWithRefs[marker] && functionsWithRefs[marker](null);
        }
      });

      currentStepDetails.editableMarkers?.forEach((marker) => {
        if (hookStateRefs[marker]) {
          hookStateRefs[marker].setEditable(true);
          hookStateRefs[marker].setOptions({
            strokeColor: "#00ff00",
          });
        }
      });

      if (currentStepDetails.drawingMode) {
        drawingManager.current.setDrawingMode(currentStepDetails.drawingMode);
      } else {
        drawingManager.current.setDrawingMode(null);
      }

      currentStepDetailsRef.current = currentStepDetails;
    }
    return () => {
      currentStepDetails?.mapMarkers?.forEach((marker) => {
        if (hookStateRefs[marker]) {
          if (Array.isArray(hookStateRefs[marker])) {
            hookStateRefs[marker].forEach((m) => m.setMap(null));
          } else {
            hookStateRefs[marker].setMap(null);
          }
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, maps, currentStepDetails]);

  // This useEffect is for doing the any step related actions.
  useEffect(() => {
    if (!map || !maps) return;
    if (
      currentStepDetails.step === 7 &&
      currentTutorial === "HERDS_SETTING_UP"
    ) {
      const animalsInsideRectangle = [];
      for (let i = 0; i < animalsCoords.length; i++) {
        const res =
          createHerdRectangle &&
          createHerdRectangle
            .getBounds()
            .contains(
              new maps.LatLng(animalsCoords[i].lat, animalsCoords[i].lng)
            );
        if (res) animalsInsideRectangle.push(animalsCoords[i]);
      }
      setHerdMarkerDetails({ coordinates: animalsInsideRectangle });
      addAnimalsWithIcon(animalsInsideRectangle);
      if (animalsInsideRectangle.length === 0) {
        setHerdMarkerDetails({ coordinates: animalsCoords });
        addAnimalsWithIcon(animalsCoords);
      }
      const label = {
        text: (animalsInsideRectangle.length || 10).toString(),
        fontFamily: "Material Icons",
        color: "#ffffff",
        fontSize: "14px",
        className: "p-15",
      };
      herdMarker && herdMarker.setLabel(label);
    }
    if (
      currentStepDetails.step === 6 &&
      currentTutorial === "VENCES_CREATING" && venceInclusionPolygon
    ) {
      let bounds = venceInclusionPolygon.getPath().getArray();
      let coords = bounds.map((each) => ({ lat: each.lat(), lng: each.lng() }));
      setVenceInclusionDetails({ coordinates: coords });
    }
    if (
      currentStepDetails.step === 8 &&
      currentTutorial === "VENCES_CREATING" &&
      venceInclusionPolygon
    ) {
      let distance = 50; // meters
      let bounds = venceInclusionPolygon.getPath().getArray();
      let polyBounds = new maps.LatLngBounds();
      bounds.forEach((each) => polyBounds.extend(each));
      let centerOfPoly = polyBounds.getCenter();
      let newPaths = [];
      bounds.forEach((each) => {
        let heading = maps.geometry.spherical.computeHeading(each, centerOfPoly);
        let newPoint = maps.geometry.spherical.computeOffset(each, distance, heading - 180);
        newPaths.push(newPoint);
      })
      const redZone = new maps.Polygon({
        paths: [newPaths, [...bounds].reverse()],
        strokeColor: "#D62D23",
        strokeOpacity: 0.1,
        strokeWeight: 0.1,
        fillColor: "#D62D23",
        fillOpacity: 0.35,
        geodesic: true,
        map: map,
      });
      setVenceInclusionRedZonePolygon(redZone);
    }
    if (
      currentStepDetails.step === 13 &&
      currentTutorial === "VENCES_CREATING" &&
      venceExclusionPolygon
    ) {
      let distance = 150; // meters
      let bounds = [...venceExclusionPolygon.getPath().getArray()];
      let coords = bounds.map((each) => ({ lat: each.lat(), lng: each.lng() }));
      setVenceExclusionDetails({ coordinates: coords }); // set the coords, so that it can be used to plot the svg polygon.

      let sum = 0
      bounds.forEach((cur, index) => {
        let next = getPoint(index + 1, bounds);
        sum += (next.lng() - cur.lng()) * (next.lat() + cur.lat());
      })
      let offsetHeadingForCurrentPoint = 0;
      let offsetHeadingForNextPoint = 0;
      if (sum > 0) { // clockwise
        offsetHeadingForCurrentPoint = 90;
        offsetHeadingForNextPoint = -90;
      } else if (sum < 0) { // counter-clockwise
        offsetHeadingForCurrentPoint = -90;
        offsetHeadingForNextPoint = 90;
      }

      // Drawing using lines intersections
      let offsetLines = [];
      let pointsWithIntersections = [];
      bounds.forEach((currentPoint, index) => {
        let nextPoint = getPoint(index + 1, bounds);
        let headingFromCurrentToNext = maps.geometry.spherical.computeHeading(currentPoint, nextPoint);
        let headingFromNextToCurrent = maps.geometry.spherical.computeHeading(nextPoint, currentPoint);

        // Calculate offset points from current and next points. These points are used to draw the parallel lines. Then we calculate the intersection of these lines. Using intersection points we can draw the polygon.
        let offsetPointFromCurrent = maps.geometry.spherical.computeOffset(currentPoint, distance, headingFromCurrentToNext + offsetHeadingForCurrentPoint);
        let offsetPointFromNext = maps.geometry.spherical.computeOffset(nextPoint, distance, headingFromNextToCurrent + offsetHeadingForNextPoint);
        pointsWithIntersections.push(offsetPointFromCurrent);
        pointsWithIntersections.push(offsetPointFromNext);
        offsetLines.push([offsetPointFromCurrent, offsetPointFromNext]);
      })

      let intersectedPoints = [];
      offsetLines.forEach((currentLinePoints, index) => {
        let nextLinePoints = getPoint(index + 1, offsetLines);
        let intersectionPoint = checkLineIntersection(currentLinePoints[0].lat(), currentLinePoints[0].lng(), currentLinePoints[1].lat(), currentLinePoints[1].lng(),
        nextLinePoints[0].lat(), nextLinePoints[0].lng(), nextLinePoints[1].lat(), nextLinePoints[1].lng());
        intersectedPoints.push(new maps.LatLng(intersectionPoint.x, intersectionPoint.y));
      })
     
      const redZone = new maps.Polygon({
        paths: [bounds, [...intersectedPoints].reverse()],
        strokeColor: "#D62D23",
        strokeOpacity: 0.1,
        strokeWeight: 0.1,
        fillColor: "#D62D23",
        fillOpacity: 0.35,
        geodesic: true,
        map: map,
      });
      setVenceExclusionRedZonePolygon(redZone);
    }
    if (
      currentStepDetails.step === 21 &&
      currentTutorial === "VENCES_ASSIGNING"
    ) {
      herdMarkerForVence &&
        herdMarkerForVence.setIcon({
          url: HerdMarkerIcon,
          scaledSize: new maps.Size(28, 28),
        });
    }
    if (
      currentStepDetails.step === 22 &&
      currentTutorial === "VENCES_ASSIGNING"
    ) {
      herdMarkerForVence &&
        herdMarkerForVence.setIcon({
          url: HerdMarkerIconYellow,
          scaledSize: new maps.Size(28, 28),
        });
    }
  }, [
    currentTutorial,
    currentStepDetails,
    map,
    maps,
    createHerdRectangle,
    venceExclusionPolygon,
    paddockFencePolygon,
    setVenceInclusionDetails,
    setVenceExclusionDetails,
  ]);

  const getPoint = (index, points) => {
    if (index < 0) {
      index += points.length;
    } else if (index >= points.length) {
        index -= points.length;
    }
    return points[index];
  }  

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: "AIzaSyC5-w5bpuiId3gF3DnR5o2cl4cq8ZuENDg",
        libraries: ["places", "drawing", "geometry"],
      }}
      defaultCenter={center}
      defaultZoom={15}
      yesIWantToUseGoogleMapApiInternals={true}
      onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      onClick={handleMapClick}
      options={{
        mapTypeId: "satellite",
        fullscreenControl: false,
        rotateControl: false,
        draggableCursor: "crosshair",
        mapTypeControl: false,
        streetViewControl: false,
      }}
    />
  );
}

export default Map;
